'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconShieldCheck, iconShieldCheckTag } from '@ni/nimble-components/dist/esm/icons/shield-check';
import { wrap } from '../../utilities/react-wrapper';

export type { IconShieldCheck };
export { iconShieldCheckTag };
export const NimbleIconShieldCheck = wrap(IconShieldCheck);